import type { ReactNode } from "react";

export function Panel({ title, action, children }: { title: string; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-[#ebe6d6] px-5 py-3.5">
        <h2 className="font-bold">{title}</h2>
        {action}
      </div>
      <div className="p-5">{children}</div>
    </section>
  );
}

export function Field({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <label className="block text-sm">
      <span className="mb-1.5 block font-medium text-[#665f4f]">{label}</span>
      {children}
    </label>
  );
}

export const inputClass = "w-full rounded-lg border border-[#d8d2bf] bg-white px-3 py-2.5 outline-none focus:border-[#2f6e5b]";

export function PrimaryButton({
  children,
  disabled,
  onClick,
  type = "button",
}: {
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
}) {
  return (
    <button type={type} disabled={disabled} onClick={onClick}
      className="rounded-lg bg-[#2f6e5b] px-4 py-2 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-50">
      {children}
    </button>
  );
}

export function SecondaryButton({
  children,
  disabled,
  onClick,
}: {
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}) {
  return (
    <button type="button" disabled={disabled} onClick={onClick}
      className="rounded-lg border border-[#cfc8b5] bg-white px-3 py-2 text-sm font-medium text-[#4d493f] disabled:opacity-50">
      {children}
    </button>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  if (!message) return null;
  return <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{message}</div>;
}

export function formatTime(ts: number | undefined): string {
  if (!ts) return "-";
  return new Date(ts).toLocaleString("zh-CN", { hour12: false });
}
